export default __webpack_public_path__ + "static/media/ic-dl-question-bank.9467ab61.svg";